import AppButton from "@/components/AppButton.vue";
import BannerPwa from "@/components/BannerPwa.vue";
import BottomNavigation from "@/components/BottomNavigation.vue";
import ModalCodigo from "@/components/ModalCodigo.vue";
import NewsCarousel from "@/components/NewsCarousel.vue";
import Slidetify from "@/components/Slidetify.vue";
import StoresScroller from "@/components/StoresScroller.vue";
import { getApplicationUrl } from "@/config";
import HomeContainer from "@/containers/HomeContainer.vue";
import Util from "@/ts/Util";
import moment from "moment";
import FavoriteScroll from "orders-module/src/components/FavoriteScroll.vue";
import { Component, Vue } from "vue-property-decorator";
import Request from "../ts/Request";

interface LastNews {
  ACTIVE: boolean;
  AUTHOR_ID: number;
  FILEURL: string;
  ID: number;
  IMAGE: string;
  NEWS: string;
  NRORG: number;
  TITLE: string;
}

@Component({
  components: {
    BottomNavigation,
    AppButton,
    ModalCodigo,
    Slidetify,
    BannerPwa,
    HomeContainer,
    FavoriteScroll,
    NewsCarousel,
    StoresScroller,
  },
})
export default class HomeFeed extends Vue {
  componentKey = 0;
  stores: any = JSON.parse(sessionStorage.getItem("stores") || "[]") || [];
  availableStores: {
    id: number;
    image: string;
    name: string;
  }[] = [];
  userData: any = JSON.parse(sessionStorage.getItem("USER_DATA") || "[]");
  organizationData: any =
    JSON.parse(sessionStorage.getItem("ORGANIZATION_DATA") || "{}") || {};
  notificationsKey = 1;
  storesAndProducts: any = [];
  homeNews: LastNews[] =
    JSON.parse(sessionStorage.getItem("LAST_NEWS") || "[]") || [];
  logo: string = this.organizationData.CONFIGURATIONS.LOGO_IMAGE;
  otherButton: any = [
    {
      name: "notification",
      iconClass: "fal",
      icon: "bell",
      colorClass: "default",
      notification: 0,
      callback: this.goToNotifications,
    },
  ];
  modalMsg = "";
  openModal = false;
  loadedNews: boolean = sessionStorage.getItem("LAST_NEWS") ? true : false;
  loadedProducts = false;
  showModalLogoff = false;

  created() {
    Util.removeTableData();

    sessionStorage.setItem("HAS_HOME", "true");
    if (!sessionStorage.getItem("BOTTOM_NAV_OPTIONS")) {
      const bottomNavOptions: any = [
        {
          id: "btn0",
          name: "Início",
          icon: "home-alt",
          active: false,
          route: "/Home",
          notification: 0,
        },
        {
          id: "btn1",
          name: "Comprar",
          icon: "store",
          active: false,
          route: "/Explorar",
          notification: 0,
        },
        {
          id: "btn2",
          name: "Carteira",
          icon: "wallet",
          active: false,
          route: "/Carteira",
          notification: 0,
        },
        {
          id: "btn3",
          name: "Compras",
          icon: "bags-shopping",
          active: false,
          route: "/PedidosRealizados",
          notification: 0,
        },
        {
          id: "btn4",
          name: "Perfil",
          icon: "user",
          active: false,
          route: "/Perfil",
          notification: 0,
        },
      ];
      sessionStorage.setItem(
        "BOTTOM_NAV_OPTIONS",
        JSON.stringify(bottomNavOptions)
      );
    }
  }

  mounted() {
    const bn: any = BottomNavigation;
    const sn: any = Slidetify;
    bn.refresh();
    sn.refresh();

    const openModalLogOff = sessionStorage.getItem("openModalLogOff") || "F";
    openModalLogOff === "T" ? (this.showModalLogoff = true) : false;

    this.getStores();
    this.getStoresAndProductsForHome();
    this.getNews();

    Util.setBackButtonBehavior(() => {});

    const lastGetNotifications: any = sessionStorage.getItem(
      "LAST_GET_NOTIFICATIONS"
    )
      ? sessionStorage.getItem("LAST_GET_NOTIFICATIONS")
      : null;
    const duration: any = lastGetNotifications
      ? moment.duration(moment().diff(lastGetNotifications))
      : null;
    const diffTime: number = duration ? duration._data.minutes : 0;

    if (diffTime >= 0 && sessionStorage.getItem("USER_ID")) {
      Util.getUserNotifications((response: any) => {
        let currentNotifications: any = [];

        if (response.length > 0) {
          currentNotifications = response;
          const oldNotificationsStorage: any = JSON.parse(
            sessionStorage.getItem("OLD_NOTIFICATIONS") || "[]"
          );
          const newNotifications =
            currentNotifications.filter(
              (objeto: any) =>
                !oldNotificationsStorage.find(
                  (obj2: any) => obj2.id == objeto.id
                )
            ) || [];
          if (currentNotifications) {
            const hasNotificationWithP = newNotifications.filter(
              (NotArray: any) => NotArray.status == "P"
            );

            if (newNotifications.length && hasNotificationWithP.length > 0) {
              sessionStorage.setItem(
                "USER_HAS_NOTIFICATIONS",
                JSON.stringify(true)
              );
              this.otherButton.find(
                (obj: any) => obj.name == "notification"
              ).notification = newNotifications.length;
            } else {
              sessionStorage.setItem(
                "USER_HAS_NOTIFICATIONS",
                JSON.stringify(false)
              );
              this.otherButton.find(
                (obj: any) => obj.name == "notification"
              ).notification = 0;
            }
          }

          sessionStorage.setItem(
            "CURRENT_NOTIFICATIONS",
            JSON.stringify(currentNotifications)
          );
          this.notificationsKey++;
        } else {
          currentNotifications = [];
          sessionStorage.setItem(
            "USER_HAS_NOTIFICATIONS",
            JSON.stringify(false)
          );
          sessionStorage.setItem(
            "CURRENT_NOTIFICATIONS",
            JSON.stringify(currentNotifications)
          );
          this.notificationsKey++;
        }
      });
    }

    sessionStorage.setItem("PARENT_EVENT", "");
    sessionStorage.setItem("EVENT_SCHEDULE_CACHE", "");
    sessionStorage.setItem("ENTERED_FROM_ORDER", "HomeFeed");
  }

  logOff() {
    Util.logOff();
  }

  cancelLogoff() {
    this.openModal = false;
    Util.cancelLogoff();
  }

  getStoresAndProductsForHome() {
    try {
      const req = new Request();
      req.body = {
        NRORG: this.organizationData.NRORG,
        USER_ID: sessionStorage.getItem("USER_ID")
          ? sessionStorage.getItem("USER_ID")
          : 1,
        TOKEN: "a",
        DEVICE_TIME: Util.getDeviceTime(),
        DELIVER_AT: null,
      };
      req.route = "getStoresAndProductsForHome";
      req.callbackSuccess = (response: any) => {
        this.storesAndProducts = response.storesAndProducts;
        this.loadedProducts = true;
      };
      req.callbackError = function (error: any) {
        console.log(error);
      };
      req.blockTouchEvents = false;
      req.showLoader = false;
      req.send();
    } catch (e) {
      console.log(e);
    }
  }

  getNews() {
    try {
      const req = new Request();
      req.body = {
        NRORG: this.organizationData.NRORG,
        MAX_RESULTS: 4,
        TOKEN: sessionStorage.getItem("TOKEN"),
      };
      req.route = "getLastNews";
      req.callbackSuccess = (response: any) => {
        sessionStorage.setItem("LAST_NEWS", JSON.stringify(response.news));
        this.homeNews = response.news;
        this.loadedNews = true;
      };
      req.callbackError = function (error: any) {
        console.log(error);
      };
      req.blockTouchEvents = false;
      req.showLoader = false;
      req.send();
    } catch (e) {
      console.log(e);
    }
  }

  setNewsDetails(ID: any, index: number) {
    sessionStorage.setItem(
      "NEWS_DETAIL",
      JSON.stringify(this.homeNews.find((news: any) => news.ID == ID))
    );
    sessionStorage.setItem("CURRENT_NEWS_INDEX", String(index));
    this.$router.push({ name: "NewsDetails" });
  }

  goToNotifications() {
    this.$router.push("Notifications");
  }

  goToStore(storeId: number) {
    if (
      sessionStorage.getItem("storeId") &&
      Number(sessionStorage.getItem("storeId")) != storeId
    ) {
      sessionStorage.removeItem("ITEMS");
      sessionStorage.removeItem("CURRENT_ORDER");
      sessionStorage.removeItem("DELIVER_AT");
    }
    sessionStorage.setItem("SHOW_ORDERBUTTON", JSON.stringify(false));
    sessionStorage.removeItem("STRUCTURE_ID");
    sessionStorage.removeItem("CLICK_PRODUCT");
    sessionStorage.setItem("storeId", storeId.toString());
    sessionStorage.setItem("CAME_FROM_QRCODE", JSON.stringify(false));
    sessionStorage.setItem("GO_TO_STORE", "true");

    this.getIfStoreHasAnySubmenu(storeId).then((response: any) => {
      if (response) {
        sessionStorage.getItem("STORE")
          ? this.$router.push("Produtos")
          : this.goProducts();
      } else {
        sessionStorage.getItem("STORE")
          ? this.$router.push("ListaDeProdutos")
          : this.goProducts("ListaDeProdutos");
      }
    });
  }

  async getIfStoreHasAnySubmenu(storeId: number) {
    const request = new Request();
    request.route = `getIfStoreHasAnySubmenu?requestType=FilterData&STORE_ID=${storeId}`;
    request.showLoader = false;
    try {
      const response = await request.get();
      return response.ifStoreHasAnySubmenu.ifHasSubmenu;
    } catch (error) {
      console.error(error);
    }
  }

  goProducts(path = "Produtos") {
    sessionStorage.setItem("loadStore", JSON.stringify(true));
    this.$router.push(path);
  }

  getStores() {
    try {
      const req = new Request();
      req.body = {
        NRORG: this.organizationData.NRORG,
        STRUCTURE_ID: sessionStorage.getItem("STRUCTURE_ID"),
        LATITUDE: sessionStorage.getItem("LATITUDE"),
        LONGITUDE: sessionStorage.getItem("LONGITUDE"),
        DEVICE_TIME: Util.getDeviceTime(),
        URL: getApplicationUrl(),
      };
      req.route = "getStoresNearUser";
      req.callbackSuccess = (response: any) => {
        const stores = response.stores;
        this.prepareStores(stores);
      };
      req.callbackError = function (error: any) {
        console.log(error);
      };
      req.blockTouchEvents = false;
      req.showLoader = false;
      req.send();
    } catch (e) {
      console.log(e);
    }
  }

  prepareStores(stores: any) {
    stores.forEach((store: any) => {
      if (
        !store.deliversToTable &&
        !store.deliversToBalcony &&
        !store.deliversToInternalLocation &&
        !store.deliversToAddress
      )
        store.opened = false;
    });

    const openedStores = stores.filter((s: any) => s.opened == true);
    const closedStores = stores.filter((s: any) => s.opened == false);

    stores = openedStores.concat(closedStores);

    this.stores = stores;
    this.availableStores = [];
    openedStores.forEach((store: any) => {
      let image = store.imageLogo;
      if (!image) image = store.imageCover;
      if (!image) image = "https://posto-xapa.s3.amazonaws.com/4878A6DD-1E79-";
      this.availableStores.push({
        id: store.id,
        image: image,
        name: store.name,
      });
    });
    sessionStorage.setItem("stores", JSON.stringify(this.stores));
  }
}
